import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { PaymentStatus } from "@bca-confirmation/models/_enums";
import { ITransaction } from "@bca-confirmation/models/transaction";
import * as confirmationActions from "@bca-confirmation/store/confirmation.actions";
import { AvoTrackingService } from "@bca-core/services/avo-tracking.service";
import * as receiptActions from "@bca-receipt/store/receipt.actions";
import { IProduct } from "@bca-shared/models/product";

import { AvoService } from "@bca-shared/utils/avo/avo.service";
import * as appActions from "@bca-store/app.actions";
import { IAction } from "@bca-store/models/action";
import { createAction } from "@bca-store/models/action-creator";
import { IRootState } from "@bca-store/store.reducers";
import { selectTotalPrice } from "@bca-store/store.selectors";
import { select, Store } from "@ngrx/store";
import { Observable, Subject, tap } from "rxjs";

@Component({
  selector: "bca-confirmation",
  templateUrl: "confirmation.component.html",
  styleUrls: ["confirmation.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationComponent implements OnInit, OnDestroy {
  representativeEmail$: Observable<string>;
  statusPaymentLoading$: Observable<boolean>;
  hasPaymentFailed$: Observable<boolean>;

  PaymentStatus = PaymentStatus;
  private readonly _destroy$ = new Subject<void>();

  transaction$: Observable<ITransaction>;
  receipt$: Observable<any>;
  totalPrice$: Observable<number>;
  products: IProduct[] = [];

  constructor(
    private store$: Store<IRootState>,
    private _avoService: AvoService,
    private _avoTrackingService: AvoTrackingService,
    private _store$: Store<IRootState>,
  ) {
    this.representativeEmail$ = this.store$.pipe(
      select(({ receipt }) => receipt.company.representative.email),
    );

    this.hasPaymentFailed$ = this.store$.pipe(
      select(({ confirmation }) => confirmation.paymentFailed),
    );

    this.initializeActions();

    this.receipt$ = this._store$.pipe(
      select(({ receipt }) => receipt),
      tap((receipt) => {
        this.products = receipt.products;
      }),
    );

    this.totalPrice$ = this._store$.pipe(select(selectTotalPrice));

    this.statusPaymentLoading$ = this._store$.pipe(
      select(({ confirmation }) => confirmation.statusPaymentLoading),
    );

    this.transaction$ = this._store$.pipe(
      select(({ confirmation }) => confirmation.transaction),
    );
  }

  ngOnInit(): void {
    this.initializeActions();
  }

  retryPayment(): void {
    this.store$.dispatch(
      this.createAction(
        new receiptActions.SetCompletedStatus({ completed: false }),
      ),
    );
    this.store$.dispatch(
      this.createAction(new confirmationActions.SetTransaction(null)),
    );
    this.store$.dispatch(this.createAction(new appActions.PreviousRoute()));
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  resetState(): void {
    this.triggerAvoButtonClick();
    this.store$.dispatch(this.createAction(new appActions.ResetState()));
  }

  private initializeActions(): void {
    this.store$.dispatch(
      this.createAction(new confirmationActions.StatusPayment()),
    );
    this.store$.dispatch(
      this.createAction(
        new confirmationActions.RedirectToIssuerLoading({ loading: false }),
      ),
    );
  }

  private triggerAvoButtonClick(): void {
    const props = {
      uniqueName: "confirmation_of_order",
      description: "thanksPage",
      clickDestination: "https://www.ns.nl/zakelijk",
      clickText: "Naar ns.nl/zakelijk",
      data: undefined,
    };

    const trackingData = this._avoTrackingService.trackButtonClick(props);

    this._avoService.buttonClick(trackingData);
  }

  private createAction(action: IAction): IAction {
    return createAction(action, ConfirmationComponent);
  }
}